import axios from "axios";
import { DistrictListKey, ProvinceListKey, SubDistrictListKey, BankListKey } from 'src/store/modules/system';
let oldController = null

export const MASTER_DATA_URLS = {
    ADD_SITE: '/v1/site/add',
    EDIT_SITE: '/v1/site/edit',
    ADD_CUSTOMER: '/v1/customer/add',
    EDIT_CUSTOMER: '/v1/customer/edit'
}

export function importSite(data) {
    return axios.post("/v1/site/importv2", data);
}
export function importCustomer(data) {
    return axios.post("/v1/customer/importv2", data)
}

export function importDriver(data) {
    return axios.post("/v1/driver/importv2", data)
}
export function downloadDriverError(errorId) {
    return axios.get("/v1/driver/download-error-file",
        {
            responseType: "arraybuffer",
            params: {
                errorId,
                type: 0
            },
        })
}
export function downloadDriverErrorImage(errorId) {
    return axios.get("/v1/driver/export-driver-image-error",
        {
            responseType: "arraybuffer",
            params: {
                errorId
            },
        })
}
export function downloadDriverSuccess(errorId) {
    return axios.get("/v1/driver/download-error-file",
        {
            responseType: "arraybuffer",
            params: {
                errorId,
                type: 1
            },
        })
}

export function importItemType(data) {
    return axios.post("/v1/goodstype/import", data)
}
export function downloadItemTypeError(errorId) {
    return axios.get("/v1/goodstype/export/error-file?", {
        responseType: "arraybuffer",
        params: {
            errorId,
        },
    })
}
export function downloadSuccessFile(errorId) {
    return axios.get("/v1/goodstype/import?", {
        responseType: "arraybuffer",
        params: {
            errorId,
        },
    })
}

export function importListSubcontractor(data) {
    return axios.post(`/v1/sub-contractor/importv2`, data)
}
export function downloadErrorFile(errorId) {
    return axios.get("/v1/site/download-error-file", {
        responseType: "arraybuffer",
        params: {
            errorId,
        },
    });
}
export function downloadErrorCustomerFile(errorId) {
    return axios.get("/v1/customer/download-error-file", {
        responseType: 'arraybuffer',
        params: {
            errorId,
        },
    });
}
export function downloadErrorSubcontractorFile(errorId) {
    return axios.get("/v1/sub-contractor/export-error", {
        responseType: 'arraybuffer',
        params: {
            errorId,
        },
    });
}
export function downloadTemplate() {
    return axios.get("/v1/templates/download/IT_TMS_SITE", {
        responseType: 'arraybuffer'
    })
}

export function downloadFile(templateUrl) {
    const url = `/v1/templates/download/${templateUrl}`;
    return axios.get(url, {
        responseType: "arraybuffer",
    });
}

export function getListSite(params) {
    return axios.get(
        `/v1/site/list?pageNo=${params.pageNo}&pageSize=${params.pageSize}&searchText=${params.searchText}&provinceId=${params.provinceId}&status=${params.status}&siteTypeId=${params.siteTypeId}&orderBy=${params.orderBy}&sorting=${params.sorting}`
    );
}
export function getListCustomerPage(params) {
    return axios.get(`/v1/customer/get-customer`, { params })
}
export function getHistory(params) {
    return axios.get(
        `/v1/site/site-history?pageNum=${params.pageNo}&pageSize=${params.pageSize}&searchText=${params.searchText}&orderBy=${params.orderBy}&sorting=${params.sorting}`
    );
}
export function getCustomerHistory(params) {
    return axios.get(`/v1/customer/history`, {
        params
    })
}
export function getDetailHistory(params) {
    return axios.get(
        `/v1/site/detail-history?pageNum=${params.pageNum}&pageSize=${params.pageSize}&searchText=${params.searchText}&siteRefId=${params.siteRefId}&orderBy=${params.orderBy}&sorting=${params.sorting}`
    );
}
export function getCustomerDetailHistory(params) {
    return axios.get(`/v1/customer/${params.id}/history`, {
        params
    })
}
export function getListCustomer() {
    return axios.get("/v1/customer/list");
}
export function getListSiteType() {
    return axios.get("/v1/site-type/list");
}
export function getGroupVehicleType() {
    return axios.get("/v1/site/group-vehicle-type");
}
export function getListSiteSubType(id) {
    return axios.get(`/v1/site-subtype/list?siteType=${id}`);
}

// get Province List cached in localStorage
export function getListProvince() {
    return new Promise(resolve => {
        const provinceList = localStorage.getItem(ProvinceListKey);
        return resolve({
            data: {
                items: provinceList ? JSON.parse(provinceList) : []
            }
        });
    })
}
export function requestRestoreHistory(id, siteId) {
    return axios.post(`/v1/site/restore/${id}?siteId=${siteId}`);
}
export function requestSetStatusSite(data) {
    return axios.post(`/v1/site/set-status`, data);
}
export function requestSetStatusCustomer(data) {
    return axios.post(`/v1/customer/set-status`, data)
}
export function requestSetStatusSubcontractor(data) {
    return axios.post(`/v1/sub-contractor/set-status`, data)
}
export function requestSetStatusDriver(data) {
    return axios.post(`/v1/driver/set-status`, data)
}
export function getSubDistrictById(id) {

    return new Promise(resolve => {
        const subDistrictList = localStorage.getItem(SubDistrictListKey);
        const subDistrictListFiltered = subDistrictList ? JSON.parse(subDistrictList).filter(item => item.districtId === id) : [];
        return resolve({
            data: {
                items: subDistrictListFiltered
            }
        })
    })
}

// get list district cached in localStorage base on provinceId
export function getListDistrict(provinceId) {

    return new Promise(resolve => {
        const districtList = localStorage.getItem(DistrictListKey);
        const districtListByProvinceId = districtList ? JSON.parse(districtList).filter(item => item.provinceId === provinceId) : [];
        return resolve({
            data: {
                items: districtListByProvinceId
            }
        })
    })
}
export function getListSubDistrict() {
    return axios.get("/v1/sub-district/list");
}
export function addSite(payload) {
    return axios.post(MASTER_DATA_URLS.ADD_SITE, payload)
}
export function editSite(payload) {
    return axios.put(MASTER_DATA_URLS.EDIT_SITE, payload);
}
export function getSite(id) {
    return axios.get(`/v1/site/detail`, { params: { siteRefId: id } });
}
export function getListHistoryLog(payload) {
    console.log(payload);
    return axios.get(`/v1/site/detail-history?searchText=&siteId=5-asd`);
}

export function getExportSiteList({
    pageNo,
    pageSize,
    searchText,
    provinceId,
    status,
    siteTypeId,
}) {
    window.open(
        `/v1/site/export?pageNo=${pageNo}&pageSize=${pageSize}&searchText=${searchText || ""
        }&status=${status || ""}&siteTypeId=${siteTypeId || ""
        }&provinceId=${provinceId || ""}`,
        "_blank"
    );
}
export function getExportCustomerList({ pageNo, pageSize, searchText, paymentTypeId, customerTypeId, customerStatus }) {
    // return axios.get(`/v1/site/export?pageNo=${pageNo}&pageSize=${pageSize}&searchText=${searchText}&customerTypeId=${customerTypeId}&siteTypeId=${siteTypeId}&provinceId=${provinceId}`, {
    //     headers: {
    //         responseType: 'blob',
    //     }
    // })
    window.open(`/v1/customer/export?pageNum=${pageNo}&pageSize=${pageSize}&searchText=${searchText || ''}&customerTypeId=${customerTypeId || ''}&paymentTypeId=${paymentTypeId || ''}&customerStatus=${customerStatus || ''}`, '_blank')
}
export function getMasterData() {
    return Promise.all([
        getListCustomer(),
        getListSiteType(),
        getListProvince(),
        getGroupVehicleType(),
    ]).then((responses) => {
        return responses.map((response) => response.data.items);
    });
}

export function getAddressPosition(params) {
    if (oldController) {
        oldController.abort();
    }
    const controller = new AbortController();
    oldController = controller;
    return axios.get("/v1/stations/location/point", {
        signal: controller.signal,
        params,
    });
}

export function getBankList() {
    return new Promise(resolve => {
        const bankList = localStorage.getItem(BankListKey);
        return resolve({
            data: {
                items: bankList ? JSON.parse(bankList) : []
            }
        });
    })
}

export function getDetailCustomer(id) {
    return axios.get(`/v1/customer/${id}/detail`);
}
export function addCustomer(payload) {
    return axios.post("/v1/customer/add", payload);
}
export function editCustomer(payload) {
    return axios.put("/v1/customer/edit", payload);
}

// check in list contract code have any code already existed in database
export function getContractCodeExisted(contractCodeList) {
    return axios.post("/v1/customer/list-existed-contract-code",
        contractCodeList)

    // return new Promise(resolve => {
    //     resolve({
    //         data: {
    //             items: []
    //         }
    //     })
    // })
}

export function getCountryList() {
    return axios.get("/v1/country/list");
}
export function getProvinceListByCountryId(params) {
    return axios.get(`/v1/province/list`, { params });
}
export function getDistrictListByProvinceId(params) {
    return axios.get(`/v1/district/list`, { params });
}
export function getSubDistrictListByDistrictId(params) {
    return axios.get(`/v1/sub-district/list`, { params });
}
export function getPostalCodeBySubDistrictId(params) {
    return axios.get(`/v1/sub-district/postal-code/list`, { params });
}
export function deleteProvinceByIds(ids) {
    return axios.delete(`/v1/province/delete`, { params: { ids: ids.join() }, responseType: "arraybuffer", });
}
export function deleteDistrictByIds(ids) {
    return axios.delete(`/v1/district/delete`, { params: { ids: ids.join() }, responseType: "arraybuffer", });
}
export function deleteSubDistrictByIds(ids) {
    return axios.delete(`/v1/sub-district/delete`, {
        params: { ids: ids.join() },
        responseType: "arraybuffer",
    });
}
export function deletePostalCodes(data) {
    return axios.put(`/v1/sub-district/postal-code/delete`, data, { responseType: "arraybuffer" });
}
export function importAddress(data) {
    return axios.post("/v1/address/import", data);
}
export function downloadErrorAddressFile(errorId) {
    return axios.get("/v1/address/download-error-file", {
        responseType: "arraybuffer",
        params: {
            errorId,
        },
    });
}
export function createProvince(params) {
    return axios.post(
        "/v1/address/createProvince",
        {
            provinceName: params.provinceName,
        },
        { params: { countryId: params.countryId } }
    );
}
export function createDistrict(params) {
    console.log("params");
    return axios.post(
        "/v1/address/createDistrict",
        {
            districtName: params.districtName,
        },
        { params: { provinceId: params.provinceId } }
    );
}
export function createSubDistrict(params) {
    return axios.post(
        "/v1/address/createSubDistrict",
        {
            subDistrictName: params.subDistrictName,
        },
        { params: { districtId: params.districtId } }
    );
}
export function updateProvince(params) {
    return axios.put(
        "/v1/address/updateProvince",
        {
            provinceName: params.provinceName,
        },
        { params: { provinceId: params.provinceId } }
    );
}
export function updateDistrict(params) {
    return axios.put(
        "/v1/address/updateDistrict",
        {
            districtName: params.districtName,
        },
        { params: { districtId: params.districtId } }
    );
}

export function updateSubDistrict(params) {
    return axios.put("/v1/address/updateSubDistrict", params.data, {
        params: { subDistrictId: params.subDistrictId },
    });
}

export function updatePostalCode(params) {
    return axios.put(
        "/v1/address/updatePostalCode",
        { postalCodeList: params.postalCodeList },
        {
            params: { subDistrictId: params.subDistrictId },
        }
    );
}

export function getTrailerList(id) {
    //delete after api is ready and link with api
    return new Promise((resolve, reject) => {
        resolve({data: {
            items: []
        }})
    })
    //Change the url for trailer list
    //return axios.get('/v1/transportcapacities/routeconfirm/' + id)
}

export function downloadStaticTemplate(fileName) {
    const url = `/static/templates/${fileName}.xlsx`; 
    return axios.get(url, { responseType: "arraybuffer" });
}



// WEBPACK FOOTER //
// ./src/services/master-data.js